// extracted by mini-css-extract-plugin
module.exports = {"page-body":"QrCodeManagement_page-body__3wchM","config-container":"QrCodeManagement_config-container__3Y8vm","side-panel":"QrCodeManagement_side-panel__1mf6v"};